import { ImageBrokenVariantIcon } from './ImageBrokenVariantIcon';

/**
 * author: Google
 * id D243B11E-D824-4185-B14F-B1C53DB11C24
 * name image-broken-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-broken-variant.svg
 * tags
 */
export const BrokenImageIcon = ImageBrokenVariantIcon;
export default BrokenImageIcon